import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { DoctorFileData } from '../models/doctor-file-data.model';
import * as _ from 'lodash';
import { PrescriptionGeneratorService } from '../enums/prescription-generator-service.enum';

export type MedicalDocumentCapabilities = {
  canPrescribeMedication: boolean;
  canCreateMedicalOrdersWithPractices: boolean;
  canCreateFreeTextMedicalOrders: boolean;
  canCreateMedicalOrderInstructions: boolean;
};

@Injectable({
  providedIn: 'root'
})
export class DoctorService {
  baseApiURL = '/doctor';
  medicalDocumentCapabilities?: MedicalDocumentCapabilities;

  constructor(private requestService: RequestService) {}

  getFileData(doctorId: string): Promise<{ [key: string]: DoctorFileData }> {
    return this.requestService.get(`${this.baseApiURL}/${doctorId}/fileData`);
  }

  createFileData(doctorId: string, formData: FormData): Promise<DoctorFileData> {
    return this.requestService.post(`${this.baseApiURL}/${doctorId}/fileData`, formData);
  }

  updateFileData(doctorFileDataId: string, formData: FormData): Promise<DoctorFileData> {
    return this.requestService.put(`${this.baseApiURL}/fileData/${doctorFileDataId}`, formData);
  }

  sendNotificationSubmittedRequestedDocumentation(doctorId: string) {
    return this.requestService.post(`/email/requestedDocumentation/doctor/${doctorId}`, {});
  }

  async getMedicalDocumentCapabilities(callId: string): Promise<MedicalDocumentCapabilities> {
    if (_.isUndefined(this.medicalDocumentCapabilities)) {
      this.medicalDocumentCapabilities = (await this.requestService.get(`${this.baseApiURL}/enrollment/capabilities`, {
        call: callId
      })) as MedicalDocumentCapabilities;
    }

    return this.medicalDocumentCapabilities;
  }

  async getPrescriptionGeneratorServiceToken(prescriptionGeneratorService: PrescriptionGeneratorService): Promise<string> {
    const response = await this.requestService.get(`${this.baseApiURL}/prescriptionGenerator/token`, { prescriptionGeneratorService });
    return response.token;
  }

  async hasEnrollmentInProviderCountry(providerId: string): Promise<boolean> {
    return await this.requestService.get(`${this.baseApiURL}/hasEnrollmentInProviderCountry`, { provider: providerId });
  }
}
